// extracted by mini-css-extract-plugin
module.exports = {"cross":"style_cross__1RH4C","textarea":"style_textarea__3aMaF","resizeHandle":"style_resizeHandle__QDEIO","phrases":"style_phrases__3Wp2K","phrase":"style_phrase__1xme_"};